export default __webpack_public_path__ + "static/media/NaharTime.8d280a4b.woff";